import React from 'react';

interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  children: React.ReactNode;
}

interface TableHeaderProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
}

interface TableBodyProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
}

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children: React.ReactNode;
}

interface TableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

interface TableHeaderCellProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const Table: React.FC<TableProps> = ({ children, className = '', ...props }) => (
  <table className={`w-full border-collapse ${className}`} style={{ tableLayout: 'fixed' }} {...props}>
    {children}
  </table>
);

export const TableHeader: React.FC<TableHeaderProps> = ({ children, className = '', ...props }) => (
  <thead className={`bg-neutral-50 border-b border-neutral-200 ${className}`} {...props}>
    {children}
  </thead>
);

export const TableBody: React.FC<TableBodyProps> = ({ children, className = '', ...props }) => (
  <tbody className={className} {...props}>
    {children}
  </tbody>
);

export const TableRow: React.FC<TableRowProps> = ({
  children,
  className = '',
  ...props
}) => (
  <tr className={`border-b border-neutral-200 hover:bg-neutral-50 ${className}`} {...props}>
    {children}
  </tr>
);

export const TableCell: React.FC<TableCellProps> = ({
  children,
  className = '',
  style,
  ...props
}) => (
  <td 
    className={`px-4 py-3 ${className}`} 
    style={{
      color: '#101828',
      fontFamily: 'Oxygen',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '14px',
      height: '56px',
      ...style
    }}
    {...props}
  >
    {children}
  </td>
);

export const TableHeaderCell: React.FC<TableHeaderCellProps> = ({
  children,
  className = '',
  style,
  ...props
}) => (
  <th
    className={`text-left px-4 py-3 font-semibold ${className}`}
    style={{
      color: '#404040',
      fontFamily: 'Oxygen',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '16px',
      height: '56px',
      verticalAlign: 'top',
      ...style
    }}
    {...props}
  >
    {children}
  </th>
);

export default Table;
